import { format, timeFormat, timeParse } from "d3";

// ===== formats =====
export function numberFormat(val) {
  return format(",.3s")(val)
    .replace(/G/, "B")
    .replace(/k/, "K");
}
export function formatM(val) {
  return Math.abs(val) >= 1000000000000000
    ? format(",.0f")(val / 1000000000000) + "T"
    : Math.abs(val) >= 10000000000
    ? format(",.1f")(val / 1000000) + "M"
    : Math.abs(val) >= 1000000000
    ? format(",.2f")(val / 1000000) + "M"
    : format(",.0f")(val);
}
export function formatDate2(date) {
  // Define a parser for ISO 8601 date format (e.g., "2025-03-10T21:35:11.123Z")
  const parseDate = timeParse("%Y-%m-%dT%H:%M:%S.%LZ");
  // Define the desired output format: "MM/DD/YYYY hh:mm:ss"
  const formatDate = timeFormat("%m/%d/%Y %I:%M:%S");
  // Try to parse the input date using the ISO format parser
  const parsedDate = parseDate(date) || new Date(date); // If parsing fails, use the Date constructor
  // Format the parsed date and return it
  return formatDate(parsedDate);
}

export const formatPercent = format(",.1%");
export function formatPercentSm(val) {
  return val === null || val === "" || val === undefined || !isFinite(val)
    ? "-"
    : format(",.0%")(val);
}
export const formatNumber = format(",.0f");
export const formatNumber2 = format(",.1f");
export const currencyFormat = ",.5r";
export function currencyFormat2(val) {
  val = Math.round(val * 1000000) / 1000000;
  return val < 0.00001
    ? format(",.1f")(val)
    : val < 0.0001
    ? format(",.2f")(val)
    : val < 0.001
    ? format(",.3f")(val)
    : val < 0.01
    ? format(",.4f")(val)
    : format(",.5f")(val);
}
export function currencyFormat3(val) {
  val = Math.round(val * 1000000) / 1000000;
  return Math.abs(val) > 10000
    ? format(",.0f")(val)
    : Math.abs(val) > 1000
    ? format(",.1f")(val)
    : Math.abs(val) > 100
    ? format(",.2f")(val)
    : Math.abs(val) > 10
    ? format(",.3f")(val)
    : format(",.4f")(val);
}
export function currencyFormat4(val) {
  if (val === null || val === "" || val === undefined || !isFinite(val)) {
    return "-";
  }
  val = Math.round(val * 1000000) / 1000000;
  return Math.abs(val) > 100
    ? format(",.0f")(val)
    : Math.abs(val) > 10
    ? format(",.1f")(val)
    : format(",.2f")(val);
}
export const currencyAxisFormat = ",.4r";
export const dateFormat = "%d %b %y";
export const tFormat = {
  day: "%d %b %y",
  week: "%d %b %y",
  month: "%b %y"
};
export const prefixOptions = {
  day: "Date:",
  week: "Week:",
  month: "Month:"
};
export const titleTexts = {
  day: "daily",
  week: "weekly",
  month: "monthly"
};
export const bucketNames = {
  "1W": "Week",
  "2W": "2 Weeks",
  "1M": "Month",
  "1Q": "Quarter",
  "6M": "Semester",
  "1Y": "Year"
};

// ===== Slice Selectors / intervals =====
export const tFormatAnalytics = {
  "1W": "%d %b %y",
  "2W": "%d %b %y",
  "1M": "%b %y",
  "1Q": "%b %y",
  "6M": "%b %y",
  "1Y": "%b %y"
};
export const tIntervalsAnalytics = {
  "1M": "day",
  "2M": "day",
  "3M": "day",
  "6M": "day",
  "1Y": "week",
  "2Y": "week",
  "3Y": "month",
  "4Y": "month",
  "5Y": "month",
  "10Y": "month"
};
export const tIntervals = {
  "1M": "day",
  "2M": "day",
  "3M": "day",
  "6M": "day",
  "1Y": "day",
  "2Y": "week",
  "3Y": "week",
  "4Y": "week",
  "5Y": "month",
  "10Y": "month",
  "20Y": "month"
};
export const tDays = {
  "1D": 1,
  "2D": 2,
  "3D": 3,
  "4D": 4,
  "1W": 5,
  "2W": 10,
  "1M": 22,
  "2M": 43,
  "3M": 65,
  "6M": 130,
  "9M": 195,
  "1Y": 261,
  "18M": 383,
  "2Y": 504,
  "3Y": 756,
  "4Y": 1008,
  "5Y": 1260,
  "10Y": 2520
};
export const tDaysW = {
  "1M": 4,
  "3M": 13,
  "6M": 26,
  "1Y": 52,
  "2Y": 104,
  "3Y": 156,
  "5Y": 261,
  "10Y": 522,
  "20Y": 1044
};
export const tDaysM = {
  "1M": 1,
  "3M": 3,
  "6M": 6,
  "1Y": 12,
  "2Y": 24,
  "3Y": 36,
  "5Y": 60,
  "10Y": 120,
  "20Y": 240
};
export const tYears = {
  "1Y": 2,
  "2Y": 3,
  "3Y": 4,
  "5Y": 6,
  "7Y": 8,
  "10Y": 11,
  "20Y": 21
}; // used in seasonality chart

// === custom variables
export const frequencyOptions = [
  { text: "DAILY", value: "D" },
  { text: "WEEKLY", value: "W" },
  { text: "HALF-MONTH", value: "2W" },
  { text: "MONTHLY", value: "M" },
  { text: "QUARTERLY", value: "Q" },
  { text: "SEMESTER", value: "S" },
  { text: "YEARLY", value: "Y" }
];

export const portfolioStatsConst = {
  var: 0,
  ave: 0,
  best: 0,
  varPnl: 0,
  avePnl: 0,
  bestPnl: 0,
  varH: 0,
  aveH: 0,
  bestH: 0,
  varPnlH: 0,
  avePnlH: 0,
  bestPnlH: 0
};

export const riskProfileItemsConst = [
  { name: "VERY CONSERVATIVE", value: 0 },
  { name: "CONSERVATIVE", value: 1 },
  { name: "MODERATE", value: 2 },
  { name: "AGGRESSIVE", value: 3 },
  { name: "VERY AGGRESSIVE", value: 4 },
  { name: "CUSTOM", value: 5 }
];

export const strategiesOptConst = [
  {
    pk: 1,
    numLegs: 1,
    data: [],
    simulations: [],
    id: 0,
    fixedCost: true,
    objectiveLeg: 1,
    first_second_strike_equal: false,
    name: "LONG FORWARD",
    rProfile: 2,
    rProfileBuyer: 2,
    rProfileSeller: 4,
    leg1: "+FORWARD",
    leg2: null,
    leg3: null,
    leg4: null,
    isStrip1: false,
    isStrip2: false,
    isStrip3: false,
    isStrip4: false,
    derivative1: 1,
    derivative2: 1,
    derivative3: 1,
    derivative4: 1,
    strike1: 0,
    strike2: 0,
    strike3: 0,
    strike4: 0,
    barrier1: 0,
    barrier2: 0,
    barrier3: 0,
    barrier4: 0,
    barrier1_2: 0,
    barrier2_2: 0,
    barrier3_2: 0,
    barrier4_2: 0,
    cost: null,
    costPerc: 0,
    active: true,
    percentage: 100,
    show: true,
    showLoading: true,
    calculated: false,
    simulated: false,
    warning: null
  }
];

export const portfolioConst = {
  percentage: 100,
  cost: 50000000,
  costPerc: 1.45,
  rProfile: 2
};

export const assetTypesConst = [
  { asset: "CURRENCY", id: 0 },
  { asset: "COMMODITY", id: 1 },
  { asset: "INTEREST RATE", id: 2 },
  { asset: "INDEX", id: 3 },
  { asset: "FUTURES", id: 4 },
  { asset: "ETF", id: 5 }
];

export const assets = [
  { asset: "CURRENCY", id: 0 },
  { asset: "COMMODITY", id: 1 },
  { asset: "INDEX", id: 2 }
];

export const operationTypesConst = [
  { asset: "SAME AXIS", id: 0 },
  { asset: "BASE 100", id: 1 },
  { asset: "TWO AXES", id: 2 },
  { asset: "TWO AXES (LOG)", id: 3 },
  { asset: "TWO AXES (INV)", id: 4 },
  { asset: "MULTIPLY", id: 5 },
  { asset: "DIVIDE", id: 6 },
  { asset: "REGRESS", id: 7 },
  { asset: "REGRESS (LOG)", id: 8 }
];

export const currencySpecsConst = [
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" },
  { pk_i_idcurrency: 0, currency_name: "N.A" }
];

export const commoditySpecsConst = [
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 },
  { pk_idcommodity: 0, fk_idproduct: "N.A", selected_contract: 0 }
];

export const etfSpecsConst = [
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idetf: 0, short_name: "N.A", long_name: "N.A" }
];

export const irSpecsConst = [
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" },
  { pk_idinterestrate: 0, interest_rate_name: "N.A", long_name: "N.A" }
];

export const indexSpecsConst = [
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idindexes: 0, short_name: "N.A", long_name: "N.A" }
];

export const futuresSpecsConst = [
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" },
  { pk_i_idfutures: 0, short_name: "N.A", long_name: "N.A" }
];

// ===== colors =====
export const colorSelection = [
  "rgb(193,0,43)",
  "rgb(255,0,59)",
  "rgb(136, 136, 136)",
  "rgb(8,114,242)",
  "rgb(19, 69, 242)"
];

export const colorSelectionMulti = [
  "rgb(15, 56, 198)",
  "rgb(19, 69, 242)",
  "rgb(8, 114, 242)",
  "rgb(26, 159, 222)",
  "rgb(136, 136, 136)",
  "rgb(96, 202, 205)",
  "rgb(53, 204, 180)",
  "rgb(9, 204, 143)"
];

export const fibonacciColorSelection = [
  "rgb(15, 56, 198)",
  "rgb(19, 69, 242)",
  "rgb(8, 114, 242)",
  "rgb(26, 159, 222)",
  "rgb(96, 202, 205)",
  "rgb(53, 204, 180)",
  "rgb(9, 204, 143)"
];
export const fibonacciAreaSelection = [
  "rgba(15, 56, 198, 0.2)",
  "rgba(19, 69, 242, 0.2)",
  "rgba(8, 114, 242, 0.2)",
  "rgba(26, 159, 222, 0.2)",
  "rgba(96, 202, 205, 0.2)",
  "rgba(53, 204, 180, 0.2)"
];
export const colorSelection3 = [
  "rgb(21, 206, 163)",
  "rgb(96, 202, 205)",
  "rgb(26, 159, 222)",
  "rgb(8, 114, 242)",
  "rgb(15, 56, 198)"
];
export const colorSelection3Alpha = [
  "rgba(21, 206, 163, 0.5)",
  "rgba(8, 114, 242, 0.5)",
  "rgba(96, 202, 205, 0.5)",
  "rgba(15, 56, 198, 0.5)",
  "rgba(26, 159, 222, 0.5)"
];
export const colorSelection4 = [
  "rgb(96, 202, 205)",
  "rgb(48,168,161)",
  "rgb(0,135,116)",
  "rgb(37, 99, 173)",
  "rgb(74, 63, 229)"
];
export const colorSelection5 = [
  "rgb(9, 204, 143)",
  "rgb(26, 159, 222)",
  "rgb(105, 105, 255)",
  "rgb(255, 121, 0)",
  "rgb(11, 150, 96)",
  "rgb(19, 123, 171)",
  "rgb(74, 63, 229)",
  "rgb(135,64,0)"
];

export const trendsColorSelection = [
  "rgb(5, 141, 204)",
  "rgb(26, 159, 222)",
  "rgb(61, 179, 212)",
  "rgb(96, 202, 205)",
  "rgb(53, 204, 180)",
  "rgb(21, 206, 163)",
  "rgb(9, 204, 143)"
];

export function colorSelection2(colorTheme = true) {
  return colorTheme
    ? [
        "rgb(21, 206, 163)",
        "rgb(53, 204, 180)",
        "rgb(96, 202, 205)",
        "rgb(61, 179, 212)",
        "rgb(26, 159, 222)",
        "rgb(26, 159, 222)",
        "rgb(19, 123, 171)",
        "rgb(8, 114, 242)",
        "rgb(19, 69, 242)",
        "rgb(15, 56, 198)",
        "rgb(255, 255, 255)",
        "rgb(255, 224, 0)"
      ]
    : [
        "rgb(21, 206, 163)",
        "rgb(53, 204, 180)",
        "rgb(96, 202, 205)",
        "rgb(61, 179, 212)",
        "rgb(26, 159, 222)",
        "rgb(26, 159, 222)",
        "rgb(19, 123, 171)",
        "rgb(8, 114, 242)",
        "rgb(19, 69, 242)",
        "rgb(15, 56, 198)",
        "rgb(0, 0, 0)",
        "rgb(255, 121, 0)"
      ];
}
export function colorSelection2Alpha(colorTheme = true) {
  return colorTheme
    ? [
        "rgba(21, 206, 163, 0.6)",
        "rgba(53, 204, 180, 0.6)",
        "rgba(96, 202, 205, 0.6)",
        "rgba(61, 179, 212, 0.6)",
        "rgba(26, 159, 222, 0.6)",
        "rgba(26, 159, 222, 0.6)",
        "rgba(19, 123, 171, 0.6)",
        "rgba(8, 114, 242, 0.6)",
        "rgba(19, 69, 242, 0.6)",
        "rgba(15, 56, 198, 0.6)",
        "rgba(255, 255, 255, 0.6)",
        "rgba(255, 224, 0, 0.6)"
      ]
    : [
        "rgba(21, 206, 163, 0.6)",
        "rgba(53, 204, 180, 0.6)",
        "rgba(96, 202, 205, 0.6)",
        "rgba(61, 179, 212, 0.6)",
        "rgba(26, 159, 222, 0.6)",
        "rgba(26, 159, 222, 0.6)",
        "rgba(19, 123, 171, 0.6)",
        "rgba(8, 114, 242, 0.6)",
        "rgba(19, 69, 242, 0.6)",
        "rgba(15, 56, 198, 0.6)",
        "rgba(0, 0, 0, 0.6)",
        "rgba(255, 121, 0, 0.6)"
      ];
}
export function colorSelectionVol(colorTheme = true) {
  return colorTheme
    ? [
        "rgb(10, 100, 242)",
        "rgb(19, 69, 242)",
        "rgb(0,0,0)",
        "rgb(171, 1, 34)",
        "rgb(255, 0, 59)"
      ]
    : [
        "rgb(0, 88, 208)",
        "rgb(19, 69, 242)",
        "rgb(240, 240, 240)",
        "rgb(171, 1, 34)",
        "rgb(255, 0, 59)"
      ];
}
export function colorSymmetry(colorTheme = true) {
  return colorTheme ? "rgb(10, 100, 242)" : "rgb(19, 69, 242)";
}
export function colorSymmetryH(colorTheme = true) {
  return colorTheme ? "rgb(38, 123, 255)" : "rgb(19, 69, 242)";
}
export function colorSymmetryAlpha(colorTheme = true) {
  return colorTheme ? "rgba(10, 100, 242, 0.15)" : "rgba(10, 100, 242, 0.15)";
}
export let colorSymmetryAlpha2 = "rgba(10, 100, 242, 0.75)";
export function colorSymmetryAlpha3(colorTheme = true) {
  return colorTheme ? "rgba(10, 100, 242, 0.60)" : "rgba(10, 100, 242, 0.8)";
}
export function colorExpo(colorTheme = true) {
  return colorTheme ? "rgb(19, 69, 242)" : "rgb(19, 69, 242)";
}
export function colorExpoAlpha(colorTheme = true) {
  return colorTheme ? "rgba(19, 69, 242, 0.15)" : "rgba(19, 69, 242, 0.15)";
}
export function colorExpoAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(19, 69, 242, 0.60)" : "rgba(19, 69, 242, 0.8)";
}
export function colorExpoAlpha3(colorTheme = true) {
  return colorTheme ? "rgba(19, 69, 242, 0.20)" : "rgba(19, 69, 242, 0.20)";
}
export function colorExpoAlpha4(colorTheme = true) {
  return colorTheme ? "rgba(19, 69, 242, 0.25)" : "rgba(19, 69, 242, 0.25)";
}
export function colorDarkExpo(colorTheme = true) {
  return colorTheme ? "rgb(15, 56, 198)" : "rgb(15, 56, 198)";
}
export function colorDarkExpoAlpha(colorTheme = true) {
  return colorTheme ? "rgba(15, 56, 198, 0.6)" : "rgba(15, 56, 198, 0.6)";
}
export function colorDarkExpoAlpha3(colorTheme = true) {
  return colorTheme ? "rgba(15, 56, 198, 0.60)" : "rgba(15, 56, 198, 0.8)";
}
export function candleAlpha(colorTheme = true) {
  return colorTheme ? 0.6 : 0.6;
}
export function colorHedge(colorTheme = true) {
  return colorTheme ? "rgb(26, 159, 222)" : "rgb(0, 202, 226)";
}
export function colorHedgeH(colorTheme = true) {
  return colorTheme ? "rgb(68, 193, 255)" : "rgb(26, 159, 222)";
}
export function colorHedgeHH(colorTheme = true) {
  return colorTheme ? "rgb(150, 223, 255)" : "rgb(0, 29, 42)";
}
export function colorHedgeAlpha(colorTheme = true) {
  return colorTheme ? "rgba(26, 159, 222, 0.20)" : "rgba(0, 202, 226, 0.20)";
}
export function colorHedgeAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(26, 159, 222, 0.6)" : "rgba(0, 202, 226, 0.85)";
}
export function colorHedgeAlpha3(colorTheme = true) {
  return colorTheme ? "rgba(26, 159, 222, 0.4)" : "rgba(0, 202, 226, 0.8)";
}
export function colorDarkHedge(colorTheme = true) {
  return colorTheme ? "rgb(4, 103, 150)" : "rgb(0, 144, 161)";
}
export function colorDarkHedgeAlpha(colorTheme = true) {
  return colorTheme ? "rgba(4, 103, 150, 0.60)" : "rgba(0, 144, 161, 0.8)";
}
export function colorNet(colorTheme = true) {
  return colorTheme ? "rgb(255, 224, 0)" : "rgb(255, 121, 0)";
}
export function colorNetAlpha(colorTheme = true) {
  return colorTheme ? "rgba(255, 224, 0, 0.75)" : "rgba(255, 121, 0, 0.8)";
}
export function colorNet_2(colorTheme = true) {
  return colorTheme ? "rgb(255, 121, 0)" : "rgb(255, 224, 0)";
}
export function colorNetAlpha_2(colorTheme = true) {
  return colorTheme ? "rgba(255, 121, 0, 0.6)" : "rgba(255, 224, 0, 0.75)";
}
export function colorNetAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(255, 224, 0, 0.2)" : "rgba(255, 121, 0, 0.2)";
}
export function colorRed(colorTheme = true) {
  return colorTheme ? "rgb(255, 0, 59)" : "rgb(255, 0, 59)";
}
export function colorDarkRed(colorTheme = true) {
  return colorTheme ? "rgb(171, 1, 34)" : "rgb(171, 1, 34)";
}
export function colorDarkerRed(colorTheme = true) {
  return colorTheme ? "rgb(102, 1, 21)" : "rgb(102, 1, 21)";
}
export let colorFwd = "rgb(9,204,143)";
export function colorFwdF(colorTheme = true) {
  return colorTheme ? "rgb(9, 204, 143)" : "rgb(9, 204, 143)";
}
export let colorFwdAlpha = "rgba(9, 204, 143, 0.4)";
export function colorFwdAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(9, 204, 143, 0.20)" : "rgba(9, 204, 143, 0.20)";
}
export function colorFwdAlpha3(colorTheme = true) {
  return colorTheme ? "rgba(9, 204, 143, 0.75)" : "rgba(9, 204, 143, 0.75)";
}
export function colorFwdAlpha4(colorTheme = true) {
  return colorTheme ? "rgba(9, 204, 143, 0.6)" : "rgba(9, 204, 143, 0.85)";
}
export function colorFwdAlpha5(colorTheme = true) {
  return colorTheme ? "rgba(9, 204, 143, 0.50)" : "rgba(9, 204, 143, 0.50)";
}
export let darkFwd = "rgb(11, 150, 96)";
export function darkFwdF(colorTheme = true) {
  return colorTheme ? "rgb(11, 150, 96)" : "rgb(11, 150, 96)";
}
export let darkFwdAlpha = "rgba(11, 150, 96, 0.4)";
export function darkFwdAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(11, 150, 96, 0.30)" : "rgba(11, 150, 96, 0.30)";
}
export let darkFwdAlpha3 = "rgba(11, 150, 96, 0.60)";
export function darkFwdAlpha4(colorTheme = true) {
  return colorTheme ? "rgba(11, 150, 96, 0.65)" : "rgba(11, 150, 96, 0.85)";
}
export function darkFwdAlpha5(colorTheme = true) {
  return colorTheme ? "rgba(11, 150, 96, 0.2)" : "rgba(11, 150, 96, 0.2)";
}
export let colorCall = "rgb(249, 49, 159)";
export let colorCallAlpha = "rgba(249, 49, 159, 0.40)";
export let colorCallAlpha2 = "rgba(249, 49, 159, 0.20)";
export let darkCall = "rgb(224, 12, 59)";
export let darkCallAlpha = "rgba(224, 12, 59, 0.40)";
export let darkCallAlpha2 = "rgba(224, 12, 59, 0.20)";
export let colorPut = "rgb(105, 105, 255)";
export let colorPutAlpha = "rgba(105, 105, 255, 0.40)";
export let colorPutAlpha2 = "rgba(105, 105, 255, 0.20)";
export let darkPut = "rgb(74, 63, 229)";
export let darkPutAlpha = "rgba(74, 63, 229, 0.40)";
export let darkPutAlpha2 = "rgba(74, 63, 229, 0.20)";
export function lightBackground(colorTheme = true) {
  return colorTheme ? "rgb(50, 50, 50)" : "rgb(230, 230, 230)";
}
export function lightBackgroundAlpha(colorTheme = true) {
  return colorTheme ? "rgba(50, 50, 50, 0.3)" : "rgba(230, 230, 230, 0.3)";
}
export function textactive(colorTheme = true) {
  return colorTheme ? "rgb(255, 255, 255)" : "rgb(0, 0, 0)";
}
export function textactiveAlpha(colorTheme = true) {
  return colorTheme ? "rgba(255, 255, 255, 0.65)" : "rgba(0, 0, 0, 0.65)";
}
export function textactiveAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(255, 255, 255, 0.25)" : "rgba(0, 0, 0, 0.25)";
}
export function textactive2(colorTheme = true) {
  return colorTheme ? "rgb(255, 255, 255)" : "rgb(255, 255, 255)";
}
export function textinactive(colorTheme = true) {
  return colorTheme ? "rgb(160, 160, 160)" : "rgba(0, 0, 0, 0.8)";
}
export function whiteGray(colorTheme = true) {
  return colorTheme ? "rgb(180, 180, 180)" : "rgb(75, 75, 75)";
}
export function whiteGrayAlpha(colorTheme = true) {
  return colorTheme ? "rgba(180, 180, 180, 0.60)" : "rgba(75, 75, 75, 0.60)";
}
export function whiteGrayAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(180, 180, 180, 0.40)" : "rgba(75, 75, 75, 0.20)";
}
export function whiteGrayAlpha3(colorTheme = true) {
  return colorTheme ? "rgba(180, 180, 180, 0.20)" : "rgba(75, 75, 75, 0.20)";
}
export function grayLightBackground(colorTheme = true) {
  return colorTheme ? "rgb(136, 136, 136)" : "rgb(170, 170, 170)";
}
export let grayLightBackgroundAlpha = "rgba(136, 136, 136, 0.60)";
export function grayLightBackgroundAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(136, 136, 136, 0.20)" : "rgba(200, 200, 200, 0.20)";
}
export function lightbackground2(colorTheme = true) {
  return colorTheme ? "rgb(100, 100, 100)" : "rgb(155, 155, 155)";
}
export function darkBackground(colorTheme = true) {
  return colorTheme ? "rgba(0, 0, 0, 1)" : "rgba(255, 255, 255, 1)";
}
export function darkBackground2(colorTheme = true) {
  return colorTheme ? "rgba(20, 20, 20, 1)" : "rgba(235, 235, 235, 1)";
}
export function darkBackground4(colorTheme = true) {
  return colorTheme ? "rgba(25, 25, 25, 1)" : "rgba(225, 225, 225, 1)";
}
export function darkBackgroundAlpha(colorTheme = true) {
  return colorTheme ? "rgba(136, 136, 136, 0.22)" : "rgba(111, 111, 111, 0.22)";
}
export function backgroundGrad1(colorTheme = true) {
  return colorTheme ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 1)";
}
export function backgroundGrad2(colorTheme = true) {
  return colorTheme ? "rgba(255, 255, 255, 0.09)" : "rgba(240, 240, 240, 1)";
}
export function dnCandles(colorTheme = true) {
  return colorTheme ? "rgba(136, 136, 136, 1)" : "rgba(111, 111, 111, 1)";
}
export function dnCandlesAlpha(colorTheme = true) {
  return colorTheme ? "rgba(136, 136, 136, 0.6)" : "rgba(111, 111, 111, 0.6)";
}
export function dnCandlesAlpha2(colorTheme = true) {
  return colorTheme ? "rgba(136, 136, 136, 0.1)" : "rgba(111, 111, 111, 0.1)";
}
export function dnCandlesAlpha3(colorTheme = true) {
  return colorTheme ? "rgba(136, 136, 136, 0.25)" : "rgba(111, 111, 111, 0.25)";
}
export let colorSelectionAlpha = [
  "rgba(193,0,43,0.5)",
  "rgba(255,0,59,0.5)",
  "rgba(136, 136, 136,0.5)",
  "rgba(8,114,242,0.5)",
  "rgba(19, 69, 242,0.5)"
];
export let colorTheme = 0;
